<template>
  <div>
  <section>
    <modal ref="qrcodetextmodalref">
      <div slot="title" v-translate>Cílová URL</div>
      <div slot="body">
          <p v-translate>Ze zadané URL systém vygeneruje QR kód, který bude zobrazen v aplikaci.</p>
          <p v-translate>Při použití vlastního QR kódu tato hodnota slouží jako cíl odkazu v aplikacích umožňující přechod na stránku po kliknutí (Live web).</p>
          <p v-translate>Pole musí být vyplněno, pokud je požadavek na zobrazení QR kódu.</p>
      </div>
    </modal>
    <modal ref="qrcodeurlmodalref">
      <div slot="title">Odkaz na externě vygenerovaný QR kód</div>
      <div slot="body">
          <p v-translate>Aplikace zobrazí QR kód z uvedené URL. Systémem vygenerovaný QR kód z hodnoty "Cílová URL" nebude využit (jeho hodnota bude využita jako cíl odkazu v aplikacích umožňujících přechod na stránku po kliknutí (Live web)).</p>
          <p v-translate>Hodnoty v poli "Cílová URL" a cílová URL ve vlastním QR kódu by měly být identické.</p>
        <p><strong><span v-translate>Doporučené rozměry obrázku:</span></strong><br/>
            <span v-translate>Poměr stran: 1:1 (čtvercový formát),</span><br/>
            <span v-translate>Minimální velikost: 320px x 320px</span><br/>
            <span v-translate>Formát: PNG</span><br/>
          </p>
      </div>
    </modal>
    <modal ref="qrcodeurlimageref">
      <div slot="title">Base64 QR kód</div>
      <div slot="body">
        <p v-translate>Umožňuje vložit tělo obrázku v base64. Systémem vygenerovaný QR kód z hodnoty "Cílová URL" nebude využit (jeho hodnota bude využita jako cíl odkazu v aplikacích umožňujících přechod na stránku po kliknutí (Live web)).</p>
        <p v-translate>Hodnoty v poli "Cílová URL" a cílová URL ve vlastním QR kódu by měly být identické.</p>
        <p><strong><span v-translate>Doporučené rozměry obrázku:</span></strong><br/>
          <span v-translate>Poměr stran: 1:1 (čtvercový formát),</span><br/>
          <span v-translate>Minimální velikost: 320px x 320px</span><br/>
          <span v-translate>Formát: PNG</span><br/>
        </p>
      </div>
    </modal>
    <div class="left">
      <detail-entity-info
          :entity="entity"
          :title="$gettext('Nastavení oznámení')"
       />
    </div>

    <div class="right">

      <div class="field_left">
        <text-input id="name"
                    v-model="entity.name"
                    :disabled="!isEditable"
                    ref="nameref"
        >
          <translate class="translate">Název oznámení</translate> *
        </text-input>
      </div>

      <div class="field_left">
        <date-picker edit-time
                     id="show_at"
                     date-format="d. m. yy"
                     attrKey="show_at"
                     v-model="entity.show_at"
                     @update-date="updateDate"
                     :disabled="!isEditable"
                     :per-minutes="true"
        >
          <translate class="translate">Zobrazit od *</translate>
        </date-picker>
      </div>

      <div class="field_right">
        <date-picker edit-time
                     id="show_to"
                     date-format="d. m. yy"
                     attrKey="show_to"
                     v-model="entity.show_to"
                     @update-date="updateDate"
                     :disabled="!isEditable"
                     :per-minutes="true"
        >
          <translate class="translate">Zobrazit do</translate>
        </date-picker>
      </div>
      <multiselect-searchbox
          :searchFunction="searchChannels"
          v-model="entity.trigger_channel_ids"
          :show-id="true"
          :disabled="!isEditable"
      >{{ $gettext('Zobrazit při sledování kanálu')}}</multiselect-searchbox>
      <div class="field_left">
        <checkbox-input
            :disabled="!isEditable"
            id="confirm_per_device"
            v-model="entity.confirm_per_device"
        >
          <translate class="translate">Po potvrzení oznámení skrýt i na dalších zařízeních</translate>
        </checkbox-input>
      </div>
    </div>
    <div v-if="showQR" class="overlay">
      <div class="overlay_inner">
        <a target="_blank" :href="entity.qr_code_text"><img v-if="qrCodeSrc.length > 0" :src="qrCodeSrc" alt="Náhled QR kódu"></a>
        <a class="btn btn_action btn_close" @click="hideQRCode" :title="$gettext('Zavřít')">Zavřít</a>
      </div>
    </div>
  </section>
    <section>
      <div class="left">
        <detail-entity-info
            :entity="entity"
            :title="$gettext('Náhledový obrázek')"
        />
      </div>

      <div class="right">
        <div class="field_left">
          <text-input id="image_url"
                      v-model="entity.image_url"
                      :disabled="!isEditable"
                      :help-text="'888x500px'"
                      ref="imageurlref"
          >
            <translate class="translate">URL náhledového obrázku</translate>
          </text-input>
        </div>
      </div>
    </section>
    <section>
      <div class="left">
        <detail-entity-info
            :entity="entity"
            :title="$gettext('QR kód')"
        />
      </div>


      <div class="right">
        <div class="field checkboxes_inline">
          <p class="field">
            <radio-input
                id="generateQr"
                name="generateQr"
                p-class="field"
                v-model="qrType"
                :val="qrType"
                :disabled="!isEditable"
            >
              <translate class="translate">Generovat QR kód</translate>
            </radio-input>
          </p>
          <p class="field">
            <radio-input
                id="customQr"
                name="customQr"
                p-class="field"
                v-model="qrType"
                :val="qrType"
                :disabled="!isEditable"
            >
              <translate class="translate">Vlastní QR kód (URL)</translate>
            </radio-input>
          </p>
          <p class="field">
            <radio-input
                id="base64Qr"
                name="base64Qr"
                p-class="field"
                v-model="qrType"
                :val="qrType"
                :disabled="!isEditable"
            >
              <translate class="translate">Vlastní QR kód (base64)</translate>
            </radio-input>
          </p>
        </div>
        <div class="field_left">
          <text-input id="qr_code_text"
                      v-model="entity.qr_code_text"
                      :disabled="!isEditable"
                      ref="qrcodetextref"
                      :help-text="$gettext('Může obsahovat zástupný symbol {language}')"
          >
            <template v-slot:afterText><img @click.stop="$refs.qrcodetextmodalref.showModal(true)" class="is_set" src="../../../../assets/images/info.svg"/></template>
            <translate class="translate">Cílová URL</translate>
            <a v-if="entity.qr_code_text" @click="showQRCode()" class="show_qr" :title="$gettext('Zobrazit QR kód')">Zobrazit QR kód</a>
          </text-input>
        </div>
        <div class="field_right ">
          <text-input
              v-if="qrType === 'customQr'"
              id="qr_code_url"
              key="qr_code_url"
              v-model="entity.qr_code_url"
              :disabled="!isEditable"
              help-text="URL"
              ref="qrcodeurlref"
          >
            <template v-slot:afterText><img @click.stop="$refs.qrcodeurlmodalref.showModal(true)" class="is_set" src="../../../../assets/images/info.svg"/></template>
            <translate class="translate">Odkaz na externí QR kód</translate>
          </text-input>
          <text-input
              v-if="qrType === 'base64Qr'"
              id="qr_code_image"
              key="qr_code_image"
              v-model="entity.qr_code_image"
              :disabled="!isEditable"
              ref="qrcodeimageref"
          >
            <template v-slot:afterText><img @click.stop="$refs.qrcodeurlimageref.showModal(true)" class="is_set" src="../../../../assets/images/info.svg"/></template>
            <translate class="translate">Base64 QR kód</translate>
            <a v-if="entity.qr_code_image" @click="showQRCode()" class="show_qr" :title="$gettext('Zobrazit QR kód')">Zobrazit QR kód</a>
          </text-input>
          <file-input
              v-if="qrType === 'base64Qr'"
              id="imageFile"
              @change="onFileChange"
              ref="imagefileref"
              :disabled="!isEditable"
              :button-text="$gettext('Nahrát PNG obrázek')"
              :accept="'.png'"
              :help-text="$gettext('PNG obrázek s QR kódem, max 10KB')"
              :max-size=10
          >
            <translate class="translate">Upload PNG souboru</translate>
          </file-input>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import AdvertisingBanners from "./../mixins/advertisingBanners";
import modal from "../../../common/Modal.vue";

export default {
  name: "AdvertisingBannerNewSettings",
  components: {DetailEntityInfo, modal},
  mixins: [AdvertisingBanners],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      showQR: false,
      qrCodeSrc: "",
      showAlert: false,
      qrType: 'generateQr',
    }
  },
  created(ChannelService, AdvertisingBannerService) {
    this.channelService = ChannelService;
    this.advertisingBannerService = AdvertisingBannerService;
  },
  methods: {
    updateDate(dateInfo) {
      this.entity[dateInfo.attrKey] = dateInfo.date
    },
    searchChannels(search, selectAll = false) {
      return this.channelService.searchChannelsByName({search: search, active_in_platform: true, id_selected_operator: this.$_loggedUser_selectedOperatorId, select_all: selectAll});
    },
    getQrCodeSrc() {
      if (this.entity.qr_code_image) {
        return Promise.resolve(this.entity.qr_code_image);
      } else if (this.entity.qr_code_url) {
        return Promise.resolve(this.entity.qr_code_url);
      } else if (this.entity.qr_code_text) {
        return this.advertisingBannerService.getQRCode({
          text: this.entity.qr_code_text,
          image: this.entity.qr_code_image,
          url: this.entity.qr_code_url
        });
      }
    },
    showQRCode: async function() {
      this.showQR = true
      this.qrCodeSrc = await this.getQrCodeSrc();
    },
    hideQRCode(){
      this.showQR = false;
      this.qrCodeSrc = "";
    },
    onFileChange(e){
      let file = e.target.files[0]
      if(file.size > 0){
        let fileReader = new FileReader();
        fileReader.onload = (fileLoadedEvent)=>{
          this.entity.qr_code_image = fileLoadedEvent.target.result;
          this.$refs.imagefileref.resetFile();
        }
        fileReader.readAsDataURL(file);
      }
    },
    getPreviewData: async function() {
      return {
        qr_code_src: await this.getQrCodeSrc(),
        image: this.entity.image_url,
      }
    }
  },
  watch:{
    qrType(){
      this.entity.qr_code_url = null;
      this.entity.qr_code_image = null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Forms/Settings.vue